// Types
import { TabBar as IProps } from './WhiteTabBar.types';

// Styling
import './WhiteTabBar.scss';
import { v4 as uuid } from 'uuid';
import { ButtonBase } from 'components/General/ButtonBase/ButtonBase';
import { useLocation, useNavigate } from 'react-router';

export const WhiteTabBar = ({ tabs, parentRoutes }: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTab = location.pathname.split('/')?.[5];

  const handleTabChange = (tab: string) => {
    navigate(`/${parentRoutes?.[0]}/${parentRoutes?.[1]}/${parentRoutes?.[2]}/${tab.split(' ').join('_').toLocaleLowerCase()}`);
  };

  return (
    <div className="white-tab-bar-container">
      { tabs.map((tab) => (
        <ButtonBase
          tagName="div"
          onClick={() => handleTabChange(tab)}
          key={uuid()}
        >
          <div
            className={`tab-container ${selectedTab === tab.split(' ').join('_').toLocaleLowerCase() && 'selected'}`}
          >
            <h3>{tab}</h3>
          </div>
        </ButtonBase>
      ))}
    </div>
  );
};
